/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssetUploadUrlDto } from '../../models/asset-upload-url-dto';
import { AssetUploadUrlRequestDto } from '../../models/asset-upload-url-request-dto';

export interface WorkerControllerGetAssetUploadUrl$Params {
  jobUuid: string;
      body: AssetUploadUrlRequestDto
}

export function workerControllerGetAssetUploadUrl(http: HttpClient, rootUrl: string, params: WorkerControllerGetAssetUploadUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<AssetUploadUrlDto>> {
  const rb = new RequestBuilder(rootUrl, workerControllerGetAssetUploadUrl.PATH, 'post');
  if (params) {
    rb.path('jobUuid', params.jobUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AssetUploadUrlDto>;
    })
  );
}

workerControllerGetAssetUploadUrl.PATH = '/worker/jobs/{jobUuid}/asset-upload-url';
